export default __webpack_public_path__ + "static/media/exclamation-triangle__gray.2e7838da.svg";